exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2uIbaPuNBSEx0DXIyxMa2r{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;display:flex;align-items:center;justify-content:center;padding:0 16px;background-color:var(--light-danger-color);pointer-events:none}._2CH3xQwn3cUTDq-jaNV7WZ{color:var(--background-color);font-size:16px;font-weight:700;line-height:1.2;letter-spacing:.04em;text-align:center;text-transform:uppercase}", ""]);

// Exports
exports.locals = {
	"banner": "_2uIbaPuNBSEx0DXIyxMa2r",
	"message": "_2CH3xQwn3cUTDq-jaNV7WZ"
};